import { Button, ButtonProps, styled } from "@mui/material";

const AddButtonContainer = styled("div")`
  display: flex;
  position: fixed;
  bottom: 30px;
  z-index: 10;
  pointer-events: none;
  margin-left: -30px;
  max-width: 1200px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const StyledAddButton = styled(Button)`
  background: #0174be;
  color: white;
  border-radius: 64px;
  display: flex;
  align-items: center;
  gap: 4px;
  pointer-events: all;
  &:hover {
    background: #2080be;
  }
`;

export const AddButton = (props: ButtonProps) => {
  return (
    <AddButtonContainer>
      <StyledAddButton {...props} />
    </AddButtonContainer>
  );
};
